module.exports = __webpack_public_path__ + "img/a639fb0fbd35bc23c76c6870faaa3c81.png";


//////////////////
// WEBPACK FOOTER
// ./classes/items/tarama/assets/sprites/tarama.png
// module id = 76
// module chunks = 0